module.exports = "<nv-react-component class=\"col-sm-12 col-xs-12 no-padding\" component=\"MentorDashboard\"></nv-react-component>";